import React from 'react';
import type { MultiSelectComponents } from '@usealloy/component-library';
import { Spinner } from '@usealloy/component-library';


interface AddLinkedChildActionLoadingIndicatorProps extends
  React.ComponentProps<typeof MultiSelectComponents.LoadingIndicator> { }

export default function AddLinkedChildActionSingleValue(
  props: AddLinkedChildActionLoadingIndicatorProps,
) {
  return (
    <div {...props}>
      <Spinner color="black" size="small" />
    </div>
  );
}
